import { TsDOM as q} from '@/scripts/core/TsDOM'
import { ProductGiftForm } from '@/scripts/theme/product-gift-form';
q.safeDefineElement(ProductGiftForm)